import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    verifiedAuthor: 'Проверенный автор',
    betaAuthor: 'Бета-автор',
    somethingWentWrong: 'Что-то пошло не так',
    loading: 'Загрузка',
  },
  en: {
    verifiedAuthor: 'Verified author',
    betaAuthor: 'Beta author',
    somethingWentWrong: 'Something went wrong',
    loading: 'Loading',
  },
})
